export interface IAddTaskCompletionTime {
  nodes: null | string[]
  task: string
  taskInfo: {
    _id?: string
    key: string
    business: string
    task: string
    taskName: string
  }
  completionTimes: {
    vehicleCategory: {
      id: string
      name: string
      averageTime: number | null
    }[]
    contCategory: {
      id: string | number
      name: string
      averageTime: number | null
    }[]
  }
  completionTimeCategories: undefined | any[] | null
}

export interface IEditTaskCompletionTime {
  node: string
  nodeName: string
  task: string
  taskInfo: {
    _id?: string
    key: string
    business: string
    task: string
    name: string
  }
  completionTimes: {
    vehicleCategory: {
      id: string
      name: string
      averageTime: number | null
    }[]
    contCategory: {
      id: string | number
      name: string
      averageTime: number | null
    }[]
  }
  completionTimeCategories: undefined | any[] | null
}

export default {}
